import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import ProfileImage from "../components/profile-photo"
import BackgroundAnimation from "../components/main-background.js"
import AssImage from "../components/name-img"

import "../style/normalize.css"
import "../style/all.scss"


const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <BackgroundAnimation/>
    <div style={{ maxWidth: `600px`, textAlign: `center`, verticalAlign: `center`, margin: `5rem auto 1.45rem auto`, paddingTop: `3rem`}}>
      <div style={{ maxWidth: `250px`, horizontalAlign: `center`, verticalAlign: `center`, margin: `auto auto auto auto`}}>
        <ProfileImage/>
      </div>
      <div style={{ maxWidth: `300px`, paddingTop: `1rem`, horizontalAlign: `center`, verticalAlign: `center`, margin: `auto auto auto auto`}}>
        <AssImage/>
      </div>
      <p style={{paddingTop: `60px`, maxWidth: `600px`, margin: `0 auto`, fontStyle: `italic`, fontWeight: `normal`, fontSize: `1.75rem`}}>
        "Learning nature, one model at a time"
      </p>
      <p style={{paddingTop: `1.5rem`, maxWidth: `600px`, margin: `0 auto`, fontSize: `1.5rem`, lineHeight: `1.5`}}>
        Postdoctoral Researcher @ <a href="https://ictp-saifr.org/" target="_blank" rel="noopener noreferrer">ICTP-SAIFR</a> | <a href="https://www.ift.unesp.br/" target="_blank" rel="noopener noreferrer">IFT-UNESP</a><br />
        Assistant Chair @ <a href="https://www.ictp-saifr.org/polsan" target="_blank" rel="noopener noreferrer">PoLSAN</a>.
      </p>
      <p style={{paddingTop: `1.5rem`, maxWidth: `600px`, margin: `0 auto`, fontSize: `1.5rem`, lineHeight: `1.5`}}>
        Ecologist (PhD)<br />
        Physicist (MSc, BSc)<br />
        Data Scientist (MBA)
      </p>
    </div>
  </Layout>
)

export default IndexPage
